/**
 * Uhrzeit-Eingabe der Monatserfassung (AP-22-D).
 *
 * Wer eine handschriftliche Liste abtippt, tippt keine Doppelpunkte. Wie im
 * Prototyp: „7" → 07:00, „730" → 07:30, „7.30" / „7,30" → 07:30. Was sich so
 * nicht lesen lässt, bleibt als Text stehen und fällt in `pruefeUhrzeit` durch.
 */

const UHRZEIT = /^([01]\d|2[0-3]):[0-5]\d$/;

export function leseUhrzeit(text: string): string | null {
  const t = text.trim().replace(/[.,]/, ':');
  if (t === '') return null;
  let h: string;
  let m: string;
  if (t.includes(':')) [h, m] = t.split(':');
  else if (t.length <= 2) [h, m] = [t, '00'];
  else [h, m] = [t.slice(0, t.length - 2), t.slice(-2)];
  if (!/^\d{1,2}$/.test(h) || !/^\d{1,2}$/.test(m)) return t;
  return `${h.padStart(2, '0')}:${m.padStart(2, '0')}`;
}

export function pruefeUhrzeit(w: string | null): string | null {
  return w === null || UHRZEIT.test(w) ? null : 'Uhrzeit als HH:MM';
}
